import React from 'react';
import "../../../static/css/layout/footer.css";

export default function Footer() {
    return (
        <footer>
            &copy; {(new Date().getFullYear())}, Cusbuzz
        </footer>
    );
}